export const COLORS = [
  'rgb(90, 103, 216)',
  'rgb(221, 107, 32)',
  'rgb(213, 63, 140)',
  'rgb(236, 201, 75)',
  'rgb(56, 161, 105)',
  'rgb(18, 58, 194)',
  'rgb(213, 242, 117)',
  'rgb(106, 194, 75)',
  'rgb(253, 55, 129)',
  'rgb(19, 209, 192)',
  'rgb(255, 121, 92)',
  'rgb(155, 231, 255)',
  'rgb(255, 188, 77)',
  'rgb(175, 0, 17)',
  'rgb(232, 213, 181)',
  'rgb(126, 57, 0)',
  'rgb(168, 159, 255)',
  'rgb(165, 180, 75)',
  'rgb(186, 30, 169)',
  'rgb(47, 72, 88)',
  'rgb(255, 107, 107)',
  'rgb(100, 149, 237)',
  'rgb(72, 209, 204)',
  'rgb(255, 165, 0)',
  'rgb(138, 43, 226)',
  'rgb(50, 205, 50)',
  'rgb(220, 20, 60)',
  'rgb(30, 144, 255)',
  'rgb(255, 20, 147)',
  'rgb(34, 139, 34)',
  'rgb(255, 215, 0)',
  'rgb(70, 130, 180)',
  'rgb(240, 128, 128)',
  'rgb(144, 238, 144)',
  'rgb(219, 112, 147)',
  'rgb(123, 104, 238)',
  'rgb(0, 206, 209)',
  'rgb(255, 99, 71)',
  'rgb(64, 224, 208)',
  'rgb(173, 255, 47)',
  'rgb(255, 192, 203)',
  'rgb(0, 128, 128)',
  'rgb(255, 0, 255)',
  'rgb(128, 0, 128)',
  'rgb(0, 255, 255)',
  'rgb(128, 128, 0)',
  'rgb(255, 128, 0)',
  'rgb(0, 128, 255)',
  'rgb(128, 255, 0)',
  'rgb(255, 0, 128)',
  'rgb(0, 255, 128)',
  'rgb(128, 0, 255)',
  'rgb(255, 128, 128)',
  'rgb(128, 255, 128)',
  'rgb(128, 128, 255)',
  'rgb(255, 255, 128)',
  'rgb(128, 255, 255)',
  'rgb(255, 128, 255)',
  'rgb(192, 192, 192)',
  'rgb(128, 128, 128)'
];
